import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "blue-grey lighten-5 text-primary" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.tDinnerTitle), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_form, { ref: "post_dinner_form" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "py-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_textarea, {
                modelValue: _ctx.content,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content) = $event)),
                rules: [_ctx.rules.required, _ctx.rules.counter500],
                label: _ctx.tDinnerTitle,
                "auto-grow": "",
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue", "rules", "label"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                onClick: _ctx.close,
                color: "error",
                variant: "text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tCancel), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                onClick: _ctx.clickPost,
                loading: _ctx.btnLoading,
                color: "primary",
                variant: "flat"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tSubmit), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}